import Product from "./ProductList";

//primereact

import PrimeReact from "primereact/api";

export default function ProductList() {
  PrimeReact.ripple = true;
  PrimeReact.appendTo = "self";
  return (
    // <ChakraProvider>
    //     <ProductProvider>
    //         <Product />
    //     </ProductProvider>
    // </ChakraProvider>

    <Product style={{ backgroundColor: "black" }} />
  );
}
